import { api } from '@shared/services/api/axios';
import { UserProfile, UserProfileResponse } from '../types/auth.types';

export const UsersService = {
  createUser: async (): Promise<boolean> => {
    try {
      const response = await api.post('/users', {});
      return response.status === 200;
    } catch {
      return false;
    }
  },

  getUserProfile: async (): Promise<UserProfile | null> => {
    try {
      const response = await api.post<UserProfileResponse>('/users/profile');
      
      const userProfile: UserProfile = {
        email: response.data.context.email,
        scopes: response.data.context.scopes.split(',').map(scope => scope.trim())
      };
      
      return userProfile;
    } catch {
      return null;
    }
  }
}; 